import { render, staticRenderFns } from "./App.vue?vue&type=template&id=617ab0be&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=617ab0be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617ab0be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/indsol-advisor/indsol-advisor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('617ab0be')) {
      api.createRecord('617ab0be', component.options)
    } else {
      api.reload('617ab0be', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=617ab0be&scoped=true", function () {
      api.rerender('617ab0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App.vue"
export default component.exports